import { useTranslation } from 'react-i18next';

import Container from '@/components/Container/Container.tsx';
import ChordButton from '@/components/ChordButton/ChordButton.tsx';
import useProgression from '@/hooks/useProgression.ts';
import useAudioPlayer from '@/hooks/useAudioPlayer.ts';
import ProgressionSquare from '@/pages/Progressions/ProgressionSquare.tsx';

function Progression() {
  const { t } = useTranslation();
  const { progressionChords, selectedProgression, setSelectedProgression } = useProgression();
  const { bar } = useAudioPlayer();

  return (
    <div className="py-4 sm:py-8">
      <Container>
        <h3 className="uppercase mb-2 text-sm sm:text-base">{t('progression.title')}</h3>
        <div className="gap-1 sm:gap-2 flex">
          {progressionChords.map((option, index) => (
            <ChordButton
              key={index}
              active={index === selectedProgression}
              option={option}
              selected={bar === index}
              onClick={() => setSelectedProgression(index)}
            />
          ))}
          {[progressionChords.length].map((num) => (
            <ProgressionSquare
              key={num}
              active={num === selectedProgression}
              number={num + 1}
              onClick={() => setSelectedProgression(num)}
            />
          ))}
        </div>
      </Container>
    </div>
  );
}

export default Progression;
